import {
	alias,
	date,
	deserialize,
	identifier,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api";
import { User } from "../users";

interface IProps {
	id?: number | null;
	user?: User | null;
	comment?: string;
	createdDate?: Date;
}

export class ProjectTaskComment {
	public static fromJson(json: IJsonObject): ProjectTaskComment {
		return deserialize(ProjectTaskComment, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectTaskComment[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(object(User))
	public user: User | null;

	@serializable(alias("created_at", date()))
	public createdDate: Date | null;

	@serializable
	public comment: string;

	constructor({
		id = null,
		user = null,
		comment = "",
		createdDate = new Date(),
	}: IProps = {}) {
		this.id = id;
		this.user = user;
		this.comment = comment;
		this.createdDate = createdDate;
	}
}
